// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-bar__logo[data-v-c70d4a96] {\n  width: 40px;\n}\n.app-bar__logo--company[data-v-c70d4a96] {\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
